import forms from '../../scenes/form/i18n/fr.js';
import home from '../../scenes/home/i18n/fr.js';
import calltoaction from '../../scenes/calltoaction/i18n/fr.js';
import simulator from '../../scenes/simulator/i18n/fr.js';

const common = {
  goback: 'Retour',
  send: 'Envoyer',
  next: 'Suivant',
  confirmation: 'confirmation',
  successMessage: 'Votre demande a été envoyée avec succès',
  errorMessage: 'Une erreur est survenue',
  close: 'Fermer',
  copyright: 'COPYRIGHT 2020 - GROUPE BANQUE POPULAIRE - TOUS DROITS RÉSERVÉS',
};
export const fr = {
  forms,
  home,
  calltoaction,
  simulator,
  common,
};
